import { render, staticRenderFns } from "./TwoColumnTextVideoModule.vue?vue&type=template&id=4fec40db&"
import script from "./TwoColumnTextVideoModule.ts?vue&type=script&lang=ts&"
export * from "./TwoColumnTextVideoModule.ts?vue&type=script&lang=ts&"
import style0 from "./TwoColumnTextVideoModule.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports